import { Banner } from '@/components/layout/Banner';
import { DesktopNav } from '@/components/layout/NavigationBar/DesktopNav';
import { MobileNav } from '@/components/layout/NavigationBar/MobileNav';

import type { BannerType } from '@/components/layout/Banner';
import type { SanityNavigationType } from '@/types/sanity';

export interface NavigationBarProps {
  navigation: SanityNavigationType;
  showBanner?: boolean;
  banner?: BannerType;
  onCloseBanner?: () => void;
  hideCTA?: boolean;
}

export const NavigationBar = ({
  navigation,
  showBanner,
  banner,
  onCloseBanner,
}: NavigationBarProps) => {
  return (
    <>
      {showBanner && <Banner banner={banner} onClose={onCloseBanner} />}
      <DesktopNav navigation={navigation} />
      <MobileNav navigation={navigation} />
    </>
  );
};
